export enum PreparationStatus {
    PREPARED = 'PREPARED',
    IN_PROGRESS = 'IN_PROGRESS',
    NOT_STARTED = 'NOT_STARTED'
}